'use client';

import { ColumnDef } from '@tanstack/react-table';
import type { ReactNode } from 'react';
import { truncateString } from '@/utils/functions/stringFormat';

const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  return date.toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export type CityKnowledgeItem = {
  id: string;
  title: string;
  municipality_code: string;
  municipality_name?: string;
  category: string;
  content_preview: string;
  created_at: string;
  actions: ReactNode;
};

export const cityKnowledgeColumns: ColumnDef<CityKnowledgeItem>[] = [
  {
    accessorKey: 'title',
    header: 'Título',
    size: 250,
    cell: function TitleCell({ row }: { row: { original: CityKnowledgeItem } }) {
      return (
        <div className="whitespace-normal break-words w-[180px]">
          {row.original.title}
        </div>
      );
    },
  },
  {
    accessorKey: 'municipality_code',
    header: 'Município',
    size: 200,
    cell: function MunicipalityCell({ row }: { row: { original: CityKnowledgeItem } }) {
      return (
        <div className="whitespace-normal break-words w-[180px]">
          {row.original.municipality_name
            ? `${row.original.municipality_name} (${row.original.municipality_code})`
            : row.original.municipality_code}
        </div>
      );
    },
  },
  {
    accessorKey: 'category',
    header: 'Categoria',
    size: 150,
    cell: function CategoryCell({ row }: { row: { original: CityKnowledgeItem } }) {
      return (
        <div className="whitespace-normal break-words w-[120px]">
          {row.original.category}
        </div>
      );
    },
  },
  {
    accessorKey: 'content_preview',
    header: 'Conteúdo',
    size: 300,
    cell: function ContentCell({ row }: { row: { original: CityKnowledgeItem } }) {
      return (
        <div className="whitespace-normal break-words w-[280px]">
          {truncateString(row.original.content_preview, 50)}
        </div>
      );
    },
  },
  {
    accessorKey: 'created_at',
    header: 'Criado em',
    size: 180,
    cell: function CreatedAtCell({ row }: { row: { original: CityKnowledgeItem } }) {
      return (
        <div className="whitespace-normal break-words w-[160px]">
          {formatDate(row.original.created_at)}
        </div>
      );
    },
  },
  {
    accessorKey: 'actions',
    header: '',
    size: 60,
    cell: function ActionsCell({ row }: { row: { original: CityKnowledgeItem } }) {
      return (
        <div
          className="w-full flex justify-end"
          onClick={(e) => e.stopPropagation()}
        >
          {row.original.actions}
        </div>
      );
    },
  },
];
